/**
 * For error handling or testing purposes.
 *
 * @category Helper functions
 */
export var emptyWebBehaviorTracker = {
    page: function () { return null; },
    consentChanged: function () { return null; },
    buttonClicked: function () { return null; },
    formInitiated: function () { return null; },
    formStepStarted: function () { return null; },
    formStepCompleted: function () { return null; },
    formCompleted: function () { return null; },
    formErred: function () { return null; },
    formCanceled: function () { return null; },
    login: function () { return null; },
    search: function () { return null; },
    searchClicked: function () { return null; },
    zipSearch: function () { return null; },
    zipSearchClick: function () { return null; },
    zipSearchClickPrefilled: function () { return null; },
    findYourBankClick: function () { return null; },
    findYourBankClickPrefilled: function () { return null; },
    calculatorInteraction: function () { return null; },
    calculatorApplyForLoan: function () { return null; },
    calculatorContactUs: function () { return null; },
    internalPromotionClicked: function () { return null; },
    componentViewed: function () { return null; },
    googleBankRedirect: function () { return null; },
    autoBankRedirect: function () { return null; },
    videoStart: function () { return null; },
    videoEnd: function () { return null; },
    videoUpdate: function () { return null; },
    discountPromoClicked: function () { return null; },
    discountOpenBox: function () { return null; },
    discountExposed: function () { return null; },
    faqRead: function () { return null; },
    feedbackGiven: function () { return null; },
};
//# sourceMappingURL=webBehaviorTracker.js.map